// extracted by mini-css-extract-plugin
module.exports = {"onboardingContainer":"styles_onboardingContainer__2x-p5","loading":"styles_loading__19ZGa"};